/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PDFTypes = {
    RentalcarContract: 'rentalcar_contract',
    DamageAccessor: 'damage_accessor',
    LawyerPaymentOrder: 'lawyer_payment_order',
    Workingimages: 'workingimages',
    RepairProof: 'repair_proof',
    DamagecaseAll: 'damagecase_all',
    Repairplan: 'repairplan',
    ReparaturAuftrag: 'Reparatur-Auftrag',
    LawyerMandate: 'lawyer_mandate',
    Mahnstatus1: 'mahnstatus_1',
    Mahnstatus2: 'mahnstatus_2',
    Mahnstatus3: 'mahnstatus_3',
    Mahnstatus4: 'mahnstatus_4',
    MahnstatusA: 'mahnstatus_a',
    MahnstatusB: 'mahnstatus_b',
    MahnstatusC: 'mahnstatus_c',
    Nebenleistungen: 'nebenleistungen',
    PaymentOrderAssignment: 'payment_order_assignment',
    RepairOrderDocumentation: 'repair-order-documentation'
} as const;

export type PDFTypes = typeof PDFTypes[keyof typeof PDFTypes];



